<template>
  <v-row>
    <v-col cols="3">
      <v-select
        outlined
        flat
        dense
        background-color="white"
        :items="listTypeGuarantee"
        v-model="params.typeGuarantee"
        label="Type Guarantee"
      ></v-select>
    </v-col>
    <v-col cols="3">
      <v-autocomplete
        outlined
        flat
        dense
        background-color="white"
        append-icon="mdi-magnify"
        item-text="name"
        item-value="id"
        v-model="params.typeGuaranteeId"
        :items="listBank"
        v-if="params.typeGuarantee === 'BG'"
      >
      </v-autocomplete>
      <v-autocomplete
        outlined
        flat
        dense
        background-color="white"
        append-icon="mdi-magnify"
        item-text="name"
        item-value="id"
        v-model="params.typeGuaranteeId"
        :items="listInsurance"
        v-if="params.typeGuarantee === 'TIBON'"
      ></v-autocomplete>
    </v-col>
    <v-col cols="3">
      <v-menu
        v-model="menuStartDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            outlined
            flat
            dense
            background-color="white"
            v-model="params.startDate"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            label="Start Date"
          ></v-text-field>
        </template>
        <v-date-picker v-model="params.startDate" @input="menuStartDate = false"></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="3">
      <v-menu
        v-model="menuEndDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            outlined
            flat
            dense
            background-color="white"
            v-model="params.endDate"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            label="End Date"
          ></v-text-field>
        </template>
        <v-date-picker v-model="params.endDate" @input="menuEndDate = false"></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="3">
      <v-btn color="success" @click="excel">
        <v-icon>
          mdi-file-excel
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import fileDownload from "js-file-download";
import { mapState } from "vuex";

export default {
  name: "report-bank-guarantee",
  data() {
    return {
      params: {
        typeGuarantee: "BG",
        typeGuaranteeId: null,
        startDate: moment()
          .startOf("month")
          .format("yyyy-MM-DD"),
        endDate: moment()
          .endOf("month")
          .format("yyyy-MM-DD"),
      },
      menuStartDate: false,
      menuEndDate: false,
      listTypeGuarantee: ["BG", "TIBON"],
    };
  },
  computed: {
    ...mapState("bank", ["listBank"]),
    ...mapState("insurance", ["listInsurance"]),
  },
  methods: {
    async excel() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/bankGuaranteeExcel", this.params)
        .then(response => {
          fileDownload(response.data, `report-bank-guarantee.xlsx`);
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([
        await this.$store.dispatch("bank/dropdown"),
        await this.$store.dispatch("insurance/dropdown"),
      ])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
  mounted() {
    this.getInitialData();
  },
};
</script>

<style></style>
